import React, { useState } from 'react';

interface GlassCardProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  onClick?: () => void;
  className?: string;
}

const GlassCard: React.FC<GlassCardProps> = ({ children, style = {}, onClick, className = '' }) => {
  const [hov, setHov] = useState(false);
  return (
    <div
      className={`glass ${className}`}
      onClick={onClick}
      onMouseEnter={() => onClick && setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        borderRadius: 'var(--r-md)',
        background: hov ? 'var(--glass-bg-hover)' : 'var(--glass-bg)',
        cursor: onClick ? 'pointer' : 'default',
        boxShadow: hov
          ? 'var(--glass-shadow-card-hover)'
          : 'var(--glass-shadow-card)',
        ...style,
      }}
    >
      <div style={{ position: 'relative', zIndex: 1 }}>{children}</div>
    </div>
  );
};

export default GlassCard;
